import React from 'react';
import PropTypes from 'prop-types';

import { AnimatePresence, motion } from 'framer-motion';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import i18n from 'i18next';

import { Button, ButtonGroup } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import styles from '../styles/customFilterNotice.module.css';

const CustomFilterNotice = ({
  isAnimated = true,
  isVisible = true,
  onEditClick = () => {},
  onClearClick = () => {},
  text = '',
}) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        animate="visible"
        className={styles.container}
        exit="hidden"
        initial="hidden"
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        variants={{
          hidden: isAnimated && { height: 0, opacity: 0 },
          visible: { height: 'auto', opacity: 1 },
        }}
      >
        <div className={styles.element}>
          <AutoAwesomeOutlinedIcon className={styles.isBrand} />
          <div>
            <Typo variant="s03">{i18n.t('custom-filter')}</Typo>
            <Typo color="secondary" variant="s02">
              {text}
            </Typo>
          </div>
        </div>
        <ButtonGroup className={styles.buttons}>
          <Button size="small" onClick={onEditClick} text={i18n.t('edit')} variant="outlined" />
          <Button size="small" onClick={onClearClick} text={i18n.t('clear')} variant="outlined" />
        </ButtonGroup>
      </motion.div>
    )}
  </AnimatePresence>
);

CustomFilterNotice.propTypes = {
  isAnimated: PropTypes.bool,
  isVisible: PropTypes.bool,
  onEditClick: PropTypes.func,
  onClearClick: PropTypes.func,
  text: PropTypes.string,
};

export default CustomFilterNotice;
